import { StripeApi } from "@/api/stripe.api";

export default async function dashboardPromocodesLoader() {
  const [coupons] = await Promise.all([StripeApi.getCoupons()]);

  return {
    coupons: coupons.data,
  };
}
